<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">C<span class="smallcaps">ONTENTS</span></h1>
<p class="toc-fm"><a href="#/005_Foreword#fm-1"><em class="italic">Foreword</em> by Mark Labberton</a></p>
<p class="toc-fm"><a href="#/006_Acknowledgments#fm-2"><em class="italic">Acknowledgments</em></a></p>
<p class="toc-fm1"><a href="#/007_Introduction#fm-3">Introduction</a></p>
<p class="toc-chap"><a href="#/008_Chapter01#ch-1">1. <span class="pad">Wisdom from Above</span></a></p>
<p class="toc-chap"><span href="#/009_Chapter02#ch-2" title="Link target outside of Sample">2. <span class="pad">Wisdom and the World around Us</span></span></p>
<p class="toc-chap"><span href="#/010_Chapter03#ch-3" title="Link target outside of Sample">3. <span class="pad">Wisdom and Humility</span></span></p>
<p class="toc-chap"><span href="#/011_Chapter04#ch-4" title="Link target outside of Sample">4. <span class="pad">Wisdom and Different Kinds of Power</span></span></p>
<p class="toc-chap"><span href="#/012_Chapter05#ch-5" title="Link target outside of Sample">5. <span class="pad">Wisdom and Healthy Practices of Power</span></span></p>
<p class="toc-chap"><span href="#/013_Chapter06#ch-6" title="Link target outside of Sample">6. <span class="pad">Wisdom and Leadership Formation</span></span></p>
<p class="toc-chap"><span href="#/014_Chapter07#ch-7" title="Link target outside of Sample">7. <span class="pad">Wisdom and Leadership Imagination</span></span></p>
<p class="toc-chap"><span href="#/015_Chapter08#ch-8" title="Link target outside of Sample">8. <span class="pad">Wisdom in Three Dimensions</span></span></p>
<p class="toc-bm"><span href="#/016_Epilogue#bm-1" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc-bm1"><span href="#/017_WorksCited#bm-2" title="Link target outside of Sample"><em class="italic">Works Cited</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Contents.vue?827f8812